import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import { Home } from "../pages/Home";
import { SpeedoMeterPage } from "../pages/Speedometer";
import { Header } from "../components";
import CssBaseline from "@mui/material/CssBaseline";

export const UserLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home />} exact />
        <Route path="/progress" element={<SpeedoMeterPage />} />
      </Routes>
      <Outlet />
    </React.Fragment>
  );
};
